import { ReactNode } from "react";
import { ButtonStyled, Typography } from "./style.tsx";

type ButtonProps = {
  startIcon?: React.ReactNode;
  onClick?: () => void;
  children: ReactNode;
  danger?: boolean;
  loading?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
  color?: "primary" | "danger" | "outline" | undefined | string;
  disabled?: boolean;
  bgColor: string;
  borderColor?: string;
};

export const ModalButton = ({
  type,
  disabled,
  color = "primay",
  startIcon,
  loading,
  onClick,
  children,
  bgColor,
  borderColor,
}: ButtonProps) => {
  const setStyle = () => {
    if (bgColor && borderColor) {
      return { backgroundColor: bgColor, borderColor: borderColor };
    } else {
      return { display: "flex" };
    }
  };

  return (
    <ButtonStyled
      variant="outlined"
      type={type}
      disabled={disabled}
      loading={loading}
      width={"fit-content"}
      style={{ minWidth: "129px", ...setStyle() }}
      startIcon={startIcon}
      onClick={onClick}
      color={color}
      bgColor={bgColor}
    >
      <Typography colors={color}>{children}</Typography>
    </ButtonStyled>
  );
};

export default ModalButton;
